import React, { useEffect, useState } from 'react';
import styled from 'styled-components';
import { IconButton } from '@material-ui/core';
import KeyboardArrowRightIcon from '@material-ui/icons/KeyboardArrowRight';
import { ICellRendererParams } from 'ag-grid-community';

const ToggleButton = styled(IconButton)`
  padding: 2px;
`;

const AnimatedArrow = styled(KeyboardArrowRightIcon)<{ $expanded: boolean }>`
  transition: transform 0.2s ease;
  transform: rotate(${(props) => (props.$expanded ? '90deg' : '0deg')});
`;

export const FaxExpandToggle = (params: ICellRendererParams) => {
  const [expanded, setExpanded] = useState(!!params.node?.expanded);

  useEffect(() => {
    const { node } = params;
    if (!node) {
      return undefined;
    }

    const onExpandedChanged = () => {
      setExpanded(!!node.expanded);
    };

    node.addEventListener('expandedChanged', onExpandedChanged);
    return () => {
      node.removeEventListener('expandedChanged', onExpandedChanged);
    };
  }, [params.node]);

  return (
    <ToggleButton
      size="small"
      aria-label={expanded ? 'Collapse fax details' : 'Expand fax details'}
      onClick={(event) => {
        event.stopPropagation();
        params.node.setExpanded(!params.node.expanded);
      }}
    >
      <AnimatedArrow $expanded={expanded} fontSize="small" />
    </ToggleButton>
  );
};
